// Общие типы для всего приложения

export const API_BASE_URL = '/api';

